<template>
  <div class="container wc-container wc-container-720" style="margin-bottom:32px;">
    <Form>
      <div class="page-settings">
        <div class="settings-item">
          <h4 class="settings-item--label">Add Modules</h4>
          <i-switch v-model="addModules"/>
          <p style="width:100%">Show Q&A and other modules under the embeded player</p>
        </div>
        <FormItem label="Embed Code">
          <Input v-model="embedCode" type="textarea" readonly :autosize="{minRows: 2,maxRows: 5}"/>
          <Button
            style="float:right; margin-top:8px;"
            type="primary"
            icon="ios-copy"
            v-clipboard:copy="embedCode"
            v-clipboard:success="onEmbedCopy">Copy to clipboard</Button>
        </FormItem>
        <FormItem label="Webcast Link">
          <Input v-model="webcastLink" type="text" readonly>
            <Button
              slot="append"
              icon="ios-copy"
              v-clipboard:copy="webcastLink"
              v-clipboard:success="onLinkCopy"></Button>
          </Input>
        </FormItem>
        <FormItem label="Speaker Q&A">
          <Input v-model="speakerLink" type="text" readonly>
            <Button
              slot="append"
              icon="ios-copy"
              v-clipboard:copy="speakerLink"
              v-clipboard:success="onLinkCopy"></Button>
          </Input>
        </FormItem>
      </div>
    </Form>
    <Card title="Audio Information" :padding="0" v-if="webcast.hasAudioRoom">
      <CellGroup>
        <Cell title="Participant Pin Code" :extra="audioRoom.pinCode" />
        <Cell title="Speaker Pin Code" :extra="audioRoom.speakerPinCode" />
      </CellGroup>
    </Card>
  </div>
</template>

<script>
import {
  mapActions, mapGetters
} from 'vuex';
export default {
  data() {
    return {
      addModules: true,
      playerWidth: '854',
      playerHeight: '1100',
      speakerLink: null,
      webcastLink: null,
    }
  },
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('audio-room', {
      audioRoom: 'getCopy'
    }),
    ...mapGetters('appsettings', {
      appSettings: 'getCopy'
    }),
    embedCode(){
      return '<iframe src="'+this.appSettings.eventUrl+'/'+this.webcast.shortLink+'/embed" width="'+this.$data.playerWidth+'" height="'+this.$data.playerHeight+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
    }
  },
  watch: {
    playerSize(){
      this.$data.playerWidth=this.$data.playerSize
    },
    addModules(){
      if(this.$data.addModules) this.$data.playerHeight = '1100'
      else this.$data.playerHeight = '480'
    }
  },
  methods: {
    onEmbedCopy(){
      this.$Message.success('Embed code copied to clipboard');
    },
    onLinkCopy(){
      this.$Message.success('Link copied to clipboard');
    }
  },
  created(){
    this.$data.speakerLink = this.appSettings.eventUrl+'/'+this.webcast.shortLink+'/speaker';
    this.$data.webcastLink = this.appSettings.eventUrl+'/'+this.webcast.shortLink;

  }
}
</script>

<style lang="scss" scoped>
	.settings {
		&-item {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 30px 0;
      &--label {
        font-weight: bold;
        text-transform: uppercase;
        font-size: 11.5px;
        color: #515a6e;
      }
		}

		&-text {
			width: 100%;
			color: #abacaf;
		}


	}
</style>
